import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  XAxis,
  YAxis,
  ResponsiveContainer,
} from 'recharts';
import { transformKPIData, getColorForKey } from '../../utils/chartUtils';
import { CustomTooltip } from './CommonComponents';


// KPI VELOCITY CHART COMPONENTS


/**
 * Render chart for KPI velocity data
 */
export const KPIVelocityChart = ({ 
  data, 
  chartType, 
  compact, 
  chartMargin, 
  responsiveProps,
  xAxisProps,
  yAxisProps,
  tooltipProps,
  legendProps 
}) => {
  const barChartData = transformKPIData(data);
  const vehTypes = [...new Set(data.map(item => item.veh_type))];

  if (chartType === "horizontal") {
    return (
      <ResponsiveContainer {...responsiveProps}>
        <BarChart layout="vertical" data={barChartData} margin={chartMargin}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis type="number" tick={{ fontSize: compact ? 10 : 12 }} />
          <YAxis
            dataKey="speed"
            type="category"
            width={compact ? 50 : 80}
            tick={{ fontSize: compact ? 10 : 12 }}
            label={!compact ? {
              value: "Speed Bucket",
              angle: -90,
              position: "left",
              style: { fontSize: 12 }
            } : undefined}
          />
          <CustomTooltip {...tooltipProps} />
          <Legend {...legendProps} />
          {vehTypes.map((type, index) => (
            <Bar
              key={type}
              dataKey={type}
              stackId="a"
              fill={getColorForKey(type, index)}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    );
  }

  return (
    <ResponsiveContainer {...responsiveProps}>
      <BarChart data={barChartData} margin={chartMargin}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
        <XAxis dataKey="speed" {...xAxisProps} />
        <YAxis
          {...yAxisProps}
          label={!compact ? {
            value: "Vehicle Count",
            angle: -90,
            position: "insideLeft",
            style: { fontSize: 12 }
          } : undefined}
        />
        <CustomTooltip {...tooltipProps} />
        <Legend {...legendProps} />
        {vehTypes.map((type, index) => (
          <Bar
            key={type}
            dataKey={type}
            stackId={chartType === "grouped" ? type : "a"}
            fill={getColorForKey(type, index)}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};
